import { Countries } from 'Constants/Common';
import { RootState } from 'state/store';

export const selectCurrency = (state: RootState) => {
    switch (state.site.country) {
        case Countries.Uk:
            return '£';
        case Countries.Us:
            return '$';
        case Countries.De:
        case Countries.At:
            return '€';
        default:
            return '£';
    }
};
